import { makeStyles, tokens } from '@fluentui/react-components'

const useStyles = makeStyles({
  accordion: {
    display: 'flex',
    flexDirection: 'column',
    gap: 0,
  },
  rowContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  item: {
    backgroundColor: 'transparent',
  },
  header: {
    minHeight: '44px',
    color: tokens.colorNeutralForeground1,
    ':hover': {
      backgroundColor: tokens.colorNeutralBackground2Hover,
    },
  },
  panel: {
    paddingTop: tokens.spacingVerticalXS,
    paddingBottom: tokens.spacingVerticalS,
    paddingLeft: 0,
    paddingRight: 0,
  },
  divider: {
    marginTop: 0,
    marginBottom: 0,
  },
  cardsContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalS,
    paddingBottom: tokens.spacingVerticalS,
  },
})

export { useStyles }
